import { Component, ComponentRef, computed, input, resource, Signal, TemplateRef, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResolvableModal } from '../../abstraction/modal';
import { ModalOption } from '../../types/modal-config';
import { TranslatePipe } from '../../../i18n/pipes/translate.pipe';
import { IconComponent } from '../../../components/icon/icon.component';

@Component({
  selector: 'soft-option-modal',
  imports: [CommonModule, TranslatePipe, IconComponent],
  templateUrl: './option-modal.component.html',
  styleUrl: './option-modal.component.css',
})
export class OptionModalComponent<T> extends ResolvableModal<T> {

  options= input<ModalOption<T>[]>([]);
  optionLoader = input<(() => Promise<ModalOption<T>[]>) | null>(null);
  optionTemplate = input<TemplateRef<{ $implicit: T }> | null>(null);
  optionComponent = input<Type<{ value: Signal<T> }> | null>(null);

  optionResource = resource({
    params: () => ({loader: this.optionLoader()}),
    loader: async (params) => {
      if(!params.params.loader)
        return undefined;
      return await params.params.loader();
    }
  });

  modalOptions = computed(() => {
    return this.optionResource.value() ?? this.options();
  })

  onClick(result: ModalOption<T>): void {
    if(result.disabled)
      return;
    this.resolve(result.value);
  }

  protected readonly resource = resource;
}
